module.exports = __webpack_public_path__ + "assets/img/thumb-Blackpurl-Landing-Page.cb4014a4.jpg";